import React from 'react';
import { Container, NavLink } from 'react-bootstrap';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import StarIcon from '@mui/icons-material/Star';
import { useHistory } from 'react-router-dom';
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const Testimonial = () => {
    const history = useHistory();
    var settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        accessibility: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ],
        beforeChange: (current, next) => {
            document
              .querySelectorAll('.slick-slide[aria-hidden="true"] a, .slick-slide[aria-hidden="true"] button, .slick-slide[aria-hidden="true"] input')
              .forEach(el => el.setAttribute('tabindex', '-1'));
          },
          afterChange: () => {
            document
              .querySelectorAll('.slick-slide:not([aria-hidden="true"]) a, .slick-slide:not([aria-hidden="true"]) button, .slick-slide:not([aria-hidden="true"]) input')
              .forEach(el => el.removeAttribute('tabindex'));
          }
    };
    return (
        <>
            <div className="rcs_testimonials">
                <Container>
                    <h5 className="text-center mb100"> What People Say </h5>
                    <div className="wrapperTestimonial position-relative">
                    <Slider className="rcs_testimonial_inner" {...settings2}>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage className="google_rev_img" src={`${ImageUrl}home/google.webp`} alt="" /> </NavLink>
                            <LazyLoadImage className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} alt="" />
                            <p>I have been a client of Belgium Webnet for several years and appreciate the exceptional service and value received. Last year,
                                I made my first big purchase, followed by repairing several pieces...
                            </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt='' className="rcs_usercircle" src="https://lh3.googleusercontent.com/a-/AOh14GhU0LSDscb0v_UfKgVKEsosHZbH3t5CjhYNq-Tc=w60-h60-p-rp-mo-br100" />
                                <div className="rcs_testi_user"> <h4>Reema Hagez</h4> </div> </NavLink>
                        </div>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="google_rev_img" src={`${ImageUrl}home/google.webp`} /> </NavLink>
                            <LazyLoadImage alt="" className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} />
                            <p>My go-to jewelry store in the Charlotte area! Always VERY friendly and helpful.  All price ranges.  Nice estate section.  Perfect repair work, done quickly.  Highly recommend...  </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="rcs_usercircle" src={`${ImageUrl}theme/venice/dummy_user.png`} />
                                <div className="rcs_testi_user"> <h4>Stephanie Blaine</h4> </div> </NavLink>
                        </div>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.yelp.com/biz/InnQkf4j02mnQUXJOtqqJw?hrid=_ZaWFPeDH1lUhWrNJZ6zrg&rh_ident=sam&rh_type=phrase/", "_blank")} to='#'>
                            <LazyLoadImage alt="" className="google_rev_img" src={`${ImageUrl}home/yelp.webp`} /> </NavLink>
                            <LazyLoadImage alt="" className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} />
                            <p>As a native Charlottean, I've been to many various jewelers thru the years for jewelry repair, watch batteries, ring cleaning, selling gold,
                                and having custom jewelry designed. ...
                            </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.yelp.com/biz/InnQkf4j02mnQUXJOtqqJw?hrid=_ZaWFPeDH1lUhWrNJZ6zrg&rh_ident=sam&rh_type=phrase", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="rcs_usercircle" src={`${ImageUrl}theme/venice/dummy_user.png`} />
                            </NavLink>
                            <div className="rcs_testi_user"> <h4>Emily H.</h4> </div>
                        </div>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.yelp.com/biz/InnQkf4j02mnQUXJOtqqJw?hrid=u-niHA_hXScxw3NZ1H78iA&rh_type=phrase&rh_ident=asaad", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="google_rev_img" src={`${ImageUrl}home/yelp.webp`} /> </NavLink>
                            <LazyLoadImage alt="" className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} />
                            <p>This is my favorite jewelry store in Charlotte! The staff is very friendly and the owner, Asaad, goes above and beyond to help. They have a huge selection of engagement rings...
                            </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.yelp.com/biz/InnQkf4j02mnQUXJOtqqJw?hrid=u-niHA_hXScxw3NZ1H78iA&rh_type=phrase&rh_ident=asaad", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="rcs_usercircle" src={`${ImageUrl}theme/venice/dummy_user.png`} /> </NavLink>
                            <div className="rcs_testi_user"> <h4>Scarlett S.</h4> </div>
                        </div>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="google_rev_img" src={`${ImageUrl}home/google.webp`} /> </NavLink>
                            <LazyLoadImage alt="" className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} />
                            <p>My experience with Belgium Webnet was great from start to finish. Sam was very patient and helped me find just what
                                I was looking for. Mr. Malak was a joy to work with as well...  </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="rcs_usercircle" src="https://lh3.googleusercontent.com/a-/AOh14GivdOLKCsSZHKqKdvW-aLbGR8OceN63WIZdDvikSQ=w60-h60-p-rp-mo-br100" />
                                <div className="rcs_testi_user"> <h4>Anna Fenno</h4> </div> </NavLink>
                        </div>
                        <div className="rcs_testi_item">
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="google_rev_img" src={`${ImageUrl}home/google.webp`} /> </NavLink>
                            <LazyLoadImage alt="" className="rcs_quote" src={`${ImageUrl}theme/venice/quote.png`} />
                            <p>I have had two occasions to use Belgium Webnet for custom work. Their desire to provide 100% satisfaction and attention to detail is outstanding....  </p>
                            <div className="rcs_test_star">
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                                <StarIcon />
                            </div>
                            <NavLink onClick={() => window.open("https://www.google.com/search?q=malak+jewelers&oq=malak+jewelers&aqs=chrome..69i57j46i175i199i512j0i22i30j69i60l3.1976j0j7&sourceid=chrome&ie=UTF-8#lrd=0x88542710fc7ccdd7:0x70a87d37ffa60fdd,1,,,", "_blank")} to='#'>
                                <LazyLoadImage alt="" className="rcs_usercircle" src="https://lh3.googleusercontent.com/a-/AOh14GhOUPYNqDPaHmjVtmwwvPvNiMYo2cBKV_2HQj_R=w60-h60-p-rp-mo-br100" /> </NavLink>
                            <div className="rcs_testi_user"> <h4>Anna Fenno</h4> </div>
                        </div>
                    </Slider>
                    </div>
                 
                
                </Container>
            </div>
        </>
    )
}

export default Testimonial;